import { FAQ } from '@models/faqs';
import { EntityAdminApiService } from './entityAdminApiService';
import { httpGet } from './apiService';

export class FAQAdminService extends EntityAdminApiService<FAQ> {
    public constructor() {
        super('/api/admin/faq');
    }

    public async getAll(): Promise<FAQ[]> {
        const response = await httpGet(this.baseUrl);

        return this.returnArrayResult<FAQ>(await response.json());
    }
}
